import { useState } from 'react'
import { Bell } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import useNotificationStore from '../../services/notificationStore'
import NotificationInbox from './NotificationInbox'

export default function NotificationBell() {
  const navigate = useNavigate()
  const unreadCount = useNotificationStore((state) => state.unreadCount)
  const [open, setOpen] = useState(false)

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Notifications"
        onClick={() => setOpen((prev) => !prev)}
        className="relative rounded-lg border border-outline bg-surface p-2 text-muted-foreground hover:bg-surface-elevated"
      >
        <Bell size={18} />
        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 min-w-5 rounded-full bg-danger px-1 text-center text-[10px] font-bold leading-5 text-white">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-12 z-50">
          <NotificationInbox onNavigate={(url) => navigate(url)} />
        </div>
      )}
    </div>
  )
}
